import { render, staticRenderFns } from "./LaunchIssues.vue?vue&type=template&id=55c404ca&scoped=true"
import script from "./LaunchIssues.vue?vue&type=script&lang=js"
export * from "./LaunchIssues.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c404ca",
  null
  
)

export default component.exports